<div class="step-wizard-dialog" [class.safari]="isSafari" [ngClass]="screenClasses">
  <div class="header" *ngIf="showHeader">
    <ng-content select="[header-details]"></ng-content>
    <div class="steps" *ngIf="showSteps">
      <app-steps *ngIf="steps" [steps]="steps" (activeStep)="onStepChanged($event)"></app-steps>
    </div>
    <div class="hr full-width"></div>
  </div>

  <div class="content content-holder {{activeStep}}">
    <ng-content select="[content]"></ng-content>
  </div>

  <div class="footer" *ngIf="showFooter">
    <div class="hr full-width"></div>
    <ng-content select="[footer-details]"></ng-content>
    <div class="actions">
      <ng-content select="[footer-actions]"></ng-content>
    </div>
  </div>
</div>
